import { Component, Input, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { ProjectsService } from '../../services/projects.service';
import { Router } from '../../../../node_modules/@angular/router';
import { ModalController, NavController } from '../../../../node_modules/@ionic/angular';
import { AuthorService } from '../../services/author.service';
import { PreviewService } from '../../services/preview.service';
import { DOCUMENT } from '@angular/platform-browser';
// import { SceneBackground } from 'src/app/models/SceneBackground';
import { Scene } from 'src/app/models/Scene';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input('show')
  public visible = false;

  // scene index must be -1, see top comment in preview.page.html for explanation.
  public sceneIndex:number = 0;
  // public activeScenes: Scene[] = [];
  // public activeBackgrounds: SceneBackground[] = [];
  constructor(
    public router: Router,
    public modalController: ModalController,
    public navController: NavController,
    public authorService: AuthorService,
    public previewService: PreviewService
    ) { }

  ngOnInit() {
  
  }

  closeModal() {
    // Annotations are added to scenes and must be saved like vrobjects
    this.modalController.dismiss();
  }

}
